/**
 * @file   src\pages\PaymentHistory.js
 * @brief  This file is responsible for payment history section.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import SelectDropDown from "../components/Common/SelectDropDown";
import { getPaymentHistory } from "../services/paymentsService";
import { formateDate, getUserId } from "../helpers/common";
import { PAYMENT_HISTORY_OPTIONS } from "../constants/common";

const PAYMENT_HISTORY_KEY = "paymentHistory";

const PaymentHistory = ({ ...props }) => {
  const { currentTab } = props;
  const userId = getUserId();
  const [options, setOptions] = useState(PAYMENT_HISTORY_OPTIONS);

  const [selectedTimePeriod, setSelectedTimePeriod] = useState(options[0]);

  // Only the payments tab pulls the history, and changing the period refetches.
  const paymentHistoryQuery = useQuery({
    queryKey: [PAYMENT_HISTORY_KEY, userId, selectedTimePeriod?.value],
    enabled: currentTab === "payments",
    queryFn: async () => {
      const response = await getPaymentHistory({
        timePeriod: selectedTimePeriod?.value,
      });
      // An API-level error empties the list, as before.
      return response?.errorCode === 0 ? (response?.result ?? []) : [];
    },
  });

  const paymentHistory = paymentHistoryQuery.data ?? [];

  const handleSelectPeriod = (selectedParam) => {
    setSelectedTimePeriod(selectedParam);
  };

  return (
    <div className="payments-wrap history-sec">
      <div className="title-sec">
        <h4>Payment history</h4>
        <div className="period">
          <p>Time period:</p>

          <SelectDropDown
            id="multi356"
            name="colors356"
            options={options}
            className="basic-single payment-select mb-0"
            classNamePrefix="select"
            value={selectedTimePeriod}
            onChange={handleSelectPeriod}
            styles={{
              dropdownIndicator: (provided, state) => ({
                ...provided,
                transform: state.selectProps.menuIsOpen && "rotate(180deg)",
              }),
            }}
            errorClass="error-msg error-msg-height d-none"
          />
        </div>
      </div>
      <div className="payment-list-sec">
        {paymentHistory.length > 0 ? (
          paymentHistory.map((paymentData, index) => {
            return (
              <div className="payment-data" key={index}>
                <div className="payment-info">
                  {paymentData?.Is_Subs_Intro === 1 ? (
                    <p>Subscription – {paymentData?.PlanName}</p>
                  ) : (
                    <p>Introduction – {paymentData?.Location}</p>
                  )}
                  <span>
                    {formateDate(paymentData?.BillingDate, "shortMonth")}
                  </span>
                </div>
                <div className="amount">${paymentData?.Total}</div>
              </div>
            );
          })
        ) : (
          <p className="text-center mt-3">No records available</p>
        )}
      </div>
    </div>
  );
};

export default PaymentHistory;
